import { Pipe, PipeTransform } from '@angular/core';
import { ScanFile } from 'src/app/models/scan.model';

@Pipe({
    name: 'filterByPressureType'
})
export class FilterByPressureTypePipe implements PipeTransform {

    transform(value: ScanFile[]): ScanFile[] {

        return value.filter((v) =>
            ['json'].includes(v.type.toLocaleLowerCase())
            && ['static', 'dynamic', 'balance'].some(substring => v.name.includes(substring))
        );

    }
}
